import React from 'react';
import { FadeInDirectionType, FadeWrapper } from '../../../component/animation/animationWrapper';
import { FontWeightType, LabelMedium } from '../../../component/Text';
import { useMobile } from '../../../hook/usePlatform';

const CompanyPhoto : React.FC = () => {
  const isMobile = useMobile();
  return (
    <div style={{ flex: 1 }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        paddingBlock: isMobile ? 30 : 80,
        paddingInline: isMobile ? 30 : 120,
      }}
      >
        <FadeWrapper
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
          }}
          direction={FadeInDirectionType.rtl}
          fadeInDistance={10}
          duration={0.5}
        >
          <img
            alt="company"
            style={{ width: '100%' }}
            src="/image/company.png"
          />
          <div>
            <LabelMedium style={{ whiteSpace: 'pre-line', marginTop: 12, fontFamily: 'inter' }}>
              {!isMobile
                ? `이러한 데이터 기반의 과학적 접근법과 따뜻한 인간미를 조화롭게
                                        결합하여, 여러분 한 분 한 분에게 최적화된 만남을 주선해 드립니다. 
                                        최신 기술과 인간적 배려를 결합한 혁신적인 접근은 
                                        고객의 시간과 노력을 절약하면서도 최적의 결과를 보장합니다.
                                        
                                        저희의 서비스는 단순히 인연을 소개하는 데 그치지 않습니다. 
                                        새로운 만남이 고객의 삶에 설렘과 특별함을 더하도록, 
                                        최고 수준의 품격과 정성을 담아 함께합니다.
                                        
                                        시럽 인연은 정성스러운 상담, 프리미엄 맞춤형 매칭, 
                                        그리고 데이터 분석 기술을 통해 
                                        당신의 삶에 새로운 장을 여는 여정에 함께하겠습니다. 
                                        
                                        이제, 특별한 당신에게 어울리는 특별한 만남을 시작하세요.
                                        삶의 깊이를 존중하며, 새로운 만남을 만들어가는
                                        
                                        `
                : `이러한 데이터 기반의 과학적 접근법과 
                                        따뜻한 인간미를 조화롭게 결합하여, 
                                        여러분 한 분 한 분에게 최적화된 
                                        만남을 주선해 드립니다. 
                                        최신 기술과 인간적 배려를 결합한 혁신적인 접근은 고객의 시간과 노력을 절약하면서도
                                        최적의 결과를 보장합니다.
                                        
                                        저희의 서비스는 단순히 인연을 소개하는데 
                                        그치지 않습니다. 
                                        새로운 만남이 고객의 삶에 설렘과 특별함을 더하도록, 최고 수준의 품격과 정성을 담아 
                                        함께합니다.
                                        
                                        시럽 인연은 정성스러운 상담, 
                                        프리미엄 맞춤형 매칭, 그리고 데이터 분석 
                                        기술을 통해 당신의 삶에 새로운 장을 여는
                                        여정에 함께하겠습니다. 
                                        
                                        이제, 특별한 당신에게 어울리는
                                        특별한 만남을 시작하세요.
                                        삶의 깊이를 존중하며, 
                                        새로운 만남을 만들어가는
                                        
                                        `}
            </LabelMedium>
            <LabelMedium style={{}} fontWeight={FontWeightType.w700}>시럽 인연</LabelMedium>
          </div>
        </FadeWrapper>
      </div>
    </div>
  );
};

export default CompanyPhoto;
